/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/**
 * Format minutes into message bubble status
 */
export default (minutesAgo, isFromCustomer) => {
    const anHourInMin = 60;
    const hourOrMinute = 1;
    let timeUnitCopy =  minutesAgo > hourOrMinute ? 'minutes' : 'minute';
    let timeUnitAmount = minutesAgo;
    const beforeOneMinCopy = isFromCustomer ? 'Sent' : 'Just now';

    if (minutesAgo >= anHourInMin) {
        timeUnitAmount = Math.floor(minutesAgo / anHourInMin);
        timeUnitCopy = timeUnitAmount > hourOrMinute ? 'hours' : 'hour';
    }
    return minutesAgo >= hourOrMinute ? `${timeUnitAmount} ${timeUnitCopy} ago` : beforeOneMinCopy;
};
